<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <img class="swiper-lazy" :data-src="item.img" alt="轮播图">
            <div class="swiper-lazy-preloader" v-if="item.title"></div>
            <div class="swiper-slide-title" v-if="item.title">
              <h1>{{item.title}}</h1>
              <p>{{item.content}}</p>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev hidden-xs"></div>
        <div class="swiper-button-next hidden-xs"></div>
      </div>
    </div>
    <!-- 大数据管理系统 -->
    <div id="bigData" class="container-fuild">
      <div class="container">
        <!-- <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn">
          <img class="img-responsive" src="@/assets/img/img1.png" alt="大数据管理系统">
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-12 text-center">
          <h2 class="bigData-title">
            宗亲文化<!-- <br> <small>About us</small> -->
          </h2>
          <p>中国人对血缘关系有一种天然的亲近感，未来社会构造依然会和宗族文化有着相当深厚的关系。所以宗族也会跟着时代变化而变化，这是它的生命力所在 。宗族是维系中国社会结构的一条纽带，是千年中华民族文化内涵的重要承载者。宗族有三个标志：祠堂、祭祖和族谱 。宗族文化中的环境、家风、宗祠、牌坊等元素充满了神秘的色彩</p>
          <p>依托宗亲关系链构建电商平台的理念，及对电商平台开发、运营、供应链管理的经验，搭建并运行宗亲电商平台。以人为链，以货为面，这是我们业务发展的契机，更是我们的基石。</p>
          <p>基于对依托宗亲关系链构建电商平台的理念，及对电商平台开发、运营、供应链管理的经验，家谷网络有限公司搭建并运行宗亲电商平台。</p>
          <p>面向大中华全球邓氏宗亲会，提供湖北区域线下实体店接入资源；依靠电商行业开发经验，提供电商平台技术支撑，提供社区电商能力输入，提供电商平台运维支撑，提供电商供应链管理支撑，并对企业组织架构及整体运营负责。</p>
          <!-- <p class="en">Chinese people have a natural sense of kinship, and the future social structure will still have
            a deep relationship with clan culture. Therefore, the clan will also change with the changes of the times,
            which is its vitality. </p>
          <p class="en">Clan is a link to maintain the social structure of China and an important carrier of the
            cultural connotation of the Chinese nation. The clan has three marks: ancestral hall, ancestor worship and
            genealogy.</p>
          <p class="en"> The environment, family tradition, ancestral temple, memorial archway and other elements of
            clan culture are full of mystery</p> -->
            <h2 class="bigData-title">
              机遇<!-- <br> <small>About us</small> -->
            </h2>
            <p>2011年，京东、阿里实际上已经占据了电商的大半壁江山。但苏宁易购，当当网在细分市场仍占有一席之地。</p>
            <p>2016年，两大巨头的市场份额进一步扩大，不少业内人士都倾向于认为，电商赛道的竞争已经尘埃落定。然后，拼多多横空出世。</p>
            <p>2021年的今天，电商的赛道依然会涌入新的运动员，必然要有新的特质：在旧的连接逻辑下，供给是稀缺的，所以人要去找货；在新的连接逻辑下，供给是充分的，所以货要去找人。</p>
            <p>所以，我们建立了家谷网络；然后，有了宗亲商海。</p>
          <!-- <a href="#" class="btn btn-lg btn-info btn-bg">MORE</a> -->
        </div>
      </div>
    </div>
    <!-- 云平台-->
    <div class="BigLife-banner container-fuild text-center">
      <div class="container">
        <h2>云平台<!-- <br> <small style="color: #FFF;">Cloud platform</small> --></h2>
        <p>云计算平台也称为云平台，是指基于硬件资源和软件资源的服务，提供计算、网络和存储能力。云计算平台可以划分为3类：以数据存储为主的存储型云平台，以数据处理为主的计算型云平台以及计算和数据存储处理兼顾的综合云计算平台</p>
      </div>
    </div>
    <!-- 客户评价 -->
    <div id="customer" class="container-fuild">
      <div class="container customer-container">
        <p class="customer-title text-center">百家姓氏<br><small>A Hundred Surnames</small></p>
        <div class="swiper-container customer-swiper hidden-xs text-center">
          <div class="swiper-wrapper">
            <div class="swiper-slide customer-block" v-for="(item,index) in customerList" :key="index">
              <div>
                <div class="customer-logo">
                  <img class="center-block" :src="item.logo" alt="logo">
                </div>
                <div class="customer-content1">{{item.title}}</div>
                <div class="customer-content2">{{item.content}}</div>
              </div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          <a href="#" class="btn btn-lg btn-info btn-bg">MORE</a>
        </div>
        <div class="row visible-xs customer-block">
          <div class="col-xs-12" v-for="(item,index) in customerList" :key="index">
            <div class="customer-logo">
              <img class="center-block" :src="item.logo" alt="logo">
            </div>
            <div class="customer-content1">
              <small>{{item.title}}</small>
            </div>
            <div class="customer-content2">
              <small>{{item.content}}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 为什么选择我们 -->
    <div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <div class="whyChooseUs-title text-center">
          <p>合作伙伴<br><small>cooperative partner</small></p>
        </div>
        <div class="row hz-logo-list">
          <div v-for="(item,index) in serverList" :key="index">
            <img :src="item.logo"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Swiper from "swiper";
  import {
    WOW
  } from 'wowjs';
  export default {
    name: "HomePage",
    data() {
      return {
        swiperList: [{
          img: require("@/assets/img/banner1.png"),
          path: "",
          title: '',
          content: '',
        }, ],
        customerList: [{
            logo: require("@/assets/img/xin-li.jpg"),
            title: "李姓",
            content: "李姓在中国的重庆、四川、云南、青海是第一大姓，河南是中国李姓的第一大省..."
          },
          {
            logo: require("@/assets/img/xin-w.jpg"),
            title: "王姓",
            content: "王姓中华姓氏之一，其始祖姬晋为黄帝后裔，王姓主要源于姬姓；..."
          },
          {
            logo: require("@/assets/img/xin-liu.jpg"),
            title: "刘姓",
            content: "据史记《汉书》《通志·氏族略》和《中国姓氏》所载，刘姓的起源主要有三支：祁姓..."
          },
          {
            logo: require("@/assets/img/xin-jiang.png"),
            title: "蒋姓",
            content: "据史记《汉书》《通志·氏族略》和《中国姓氏》所载，蒋姓的起源主要有二支..."
          },
        ],
        serverList: [{
            logo: require("@/assets/img/hz-logo.jpg"),
          },
          {
            logo: require("@/assets/img/hz-logo.jpg"),
          },
        ]
      };
    },
    beforeCreate:function(){
    	window.scrollTo(0, 0);
    },
    mounted() {
      /* banner-swiper */
      new Swiper(".banner-swiper", {
        loop: true, // 循环模式选项
        effect: 'fade',
        //自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // 延迟加载
        lazy: {
          loadPrevNext: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      });
      /* customer-swiper */
      new Swiper(".customer-swiper", {
        loop: true, // 循环模式选项
        slidesPerView: 3,
        //自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      });
      /* wowjs动画 */
      var wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      })
      wow.init();
    }
  };
</script>
<style scoped>
  /* 整体盒子 */
  #HomePage {
    width: 100%;
  }

  /* 轮播图 */
  #swiper {
    height: 600px;
  }

  #swiper .banner-swiper {
    width: 100%;
    height: 100%;
  }

  #swiper .banner-swiper .swiper-slide img {
    width: 100%;
    height: 100%;
  }

  #swiper .banner-swiper .swiper-slide {
    position: relative;
  }

  #swiper .banner-swiper .swiper-slide-title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999999;
    width: 100%;
    height: 100%;
    color: #fff;
    background: rgba(51, 51, 51, 0.534);
    text-align: center;
    line-height: 80px;
  }

  #swiper .banner-swiper .swiper-slide-title>h1 {
    font-size: 50px;
    margin-top: 12%;
  }

  #swiper .banner-swiper .swiper-slide-title>p {
    font-size: 20px;
    margin-top: 1%;
    font-weight: 700;
  }

  /* 大数据管理系统 */
  #bigData {
    padding: 80px 0;
    transition: all ease 0.6s;
    box-sizing: border-box;
  }

  #bigData .bigData-title {
    padding-bottom: 10px;
    /* border-bottom: 1px solid #ccc; */
  }

  #bigData p {
    font-size: 16px;
    color: #333;
    line-height: 2rem;
  }

  #bigData .en {
    font-size: 15px;
    color: #b1b1b1;
    line-height: 2rem;
  }

  #bigData .bigData-device {
    margin: 50px 0 20px;
  }

  .btn-bg {
    padding: 10px 25px;
    border-radius: 60px;
    background-color: #f2d6bc;
	border: 0;
  }

  .BigLife-banner {
    color: #fff;
    font-size: 30px;
    padding: 60px 0;
    max-height: 300px;
    background-image: url("../assets/img/ypt.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: scroll;
    background-position: center center;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .BigLife-banner p {
    font-size: 0.7em;
    margin-top: 30px;
  }

  /* 您身边的IT专家 */
  #contactUs {
    color: #fff;
    height: 400px;
    background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    transition: all ease 0.6s;
  }

  #contactUs .contactUs-container {
    padding-top: 50px;
  }

  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 40px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 48px;
    height: 48px;
    margin: 30px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
    background: url("../assets/img/weixin.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }

  #contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
    background: url("../assets/img/weibo.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }

  #contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
    background: url("../assets/img/twitter.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }

  /* 客户评价 */
  #customer {
    padding: 50px 0;
    box-sizing: border-box;
    /* background: #efefef; */
    transition: all ease 0.6s;
  }

  #customer .customer-title {
    font-size: 30px;
    color: rgb(102, 102, 102);
    margin: 0 0 30px;
  }

  #customer .customer-block {
    background: #fff;
    padding: 30px;
  }
  #customer .customer-block>div{
    background: url("../assets/img/xinbg.png") ;
    background-size: 100% 100%;
    padding: 50px 30px;
  }

  #customer .customer-logo img {
    width: 200px;
    height: 200px;
  }

  #customer .customer-yh img {
    width: 34px;
    height: 34px;
  }

  #customer .customer-content1 {
    font-size: 24px;
    color: #000000;
    padding: 20px 0;
    text-align: center;
    font-weight: 900;
  }

  #customer .customer-content2 {
     font-size: 20px;
    padding-top: 20px;
  }

  /* 为什么选择我们 */
  #whyChooseUs {
    padding: 50px 0;
  }

  #whyChooseUs .whyChooseUs-title {
    font-size: 30px;
    font-weight: 500;
    margin-bottom: 50px;
  }
  .hz-logo-list{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  .hz-logo-list div{
    width: 20%;
    padding: 20px;
  }
  .hz-logo-list div img{
    width: 100%;
    padding: 20px;
  }


  /* 媒体查询（手机） */
  @media screen and (max-width: 768px) {
    #swiper {
      height: 250px;
    }

    #bigData {
      padding: 0px;
    }
    #bigData .container {
      padding: 0px;
    }

    #bigData .bigData-title {
      font-size: 20px;
    }

    #bigData .bigData-device {
      font-size: 20px;
      margin: 10px 0 10px;
    }

    #contactUs {
      height: 200px;
      transition: all ease 0.6s;
    }

    #contactUs .contactUs-container {
      padding-top: 0;
    }

    #contactUs .contactUs-container h1 {
      font-size: 25px;
    }

    #contactUs .contactUs-container h3 {
      font-size: 18px;
    }

    #contactUs .contactUs-container button {
      width: 200px;
      height: 30px;
      margin-top: 20px;
    }

    #contactUs .contactUs-container .contactUs-contactWay span {
      display: inline-block;
      width: 28px;
      height: 28px;
      margin: 10px;
    }
    .BigLife-banner {
      padding: 30px 0;
      background-size: cover;
    }
    .BigLife-banner p {
      font-size: 16px;
      margin-top: 0px;
    }
     h2 {
        font-size: 22px;
    }
    .btn-bg {
      padding: 5px 10px;
      font-size: 14px;
    }

    #customer {
      padding: 0;
      box-sizing: border-box;
      background: #fff;
    }

    #customer .customer-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 0;
    }

    #customer .customer-logo img {
      width: 58px;
      height: 58px;
    }

    #customer .customer-block {
      padding: 0 30px;
    }

    #customer .customer-block>div {
      padding: 30px;
       margin: 20px 0;
    }

    #customer .customer-content1 {
      padding: 10px 0;
    }

    #customer .customer-content2 {
       font-size: 20px;
      padding-top: 0px;
    }

    #whyChooseUs {
      padding: 0;
      transition: all ease 0.6s;
    }

    #whyChooseUs .whyChooseUs-title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .hz-logo-list div{
      width: 50%;
      padding: 0px;
    }
    .hz-logo-list div img{
      width: 80%;
      padding: 20px;
      margin: auto;
    }

  }

  /* 媒体查询（平板） */
  @media screen and (min-width: 768px) and (max-width: 1170px) {
    #swiper {
      height: 400px;
    }

    #bigData {
      padding: 60px;
    }

    #bigData .bigData-title {
      font-size: 30px;
    }

    #bigData .bigData-device {
      font-size: 30px;
      margin: 30px 0 15px;
    }
    #customer .customer-logo img {
      width: 58px;
      height: 58px;
    }

    #contactUs {
      height: 300px;
    }

    #contactUs .contactUs-container {
      padding-top: 50px;
    }

    #contactUs .contactUs-container h1 {
      font-size: 30px;
    }

    #contactUs .contactUs-container h3 {
      font-size: 20px;
    }

    #contactUs .contactUs-container button {
      width: 300px;
      height: 50px;
      margin-top: 30px;
    }

    #contactUs .contactUs-container .contactUs-contactWay span {
      display: inline-block;
      width: 32px;
      height: 32px;
      margin: 15px;
    }

    #customer .customer-title {
      font-size: 24px;
    }
    .BigLife-banner {
      padding: 40px 0;
      background-size: cover;
    }

    #whyChooseUs {
      padding: 0;
    }

    #whyChooseUs .whyChooseUs-title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .hz-logo-list div{
      width: 30%;
      padding: 0px;
    }
    .hz-logo-list div img{
      width: 80%;
      padding: 20px;
      margin: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue